import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { ShowMoreBtn } from '../../components/ShowMoreBtn';
import { WrapContainer } from '../../components/WrapContainer';
import { selectActiveTab } from '../../selectors/activeTab';
import { ETabType } from '../../types/filters';
import { IApplicationState } from '../../types/redux';
import { EGetFavoriteEntitiesStatus } from '../../types/results';

interface IShowMoreBtnContainer {
  isExperimentEnabled?: boolean;
}

export const ShowMoreBtnContainer: React.FC<IShowMoreBtnContainer> = ({ isExperimentEnabled }) => {
  const hasMore = useSelector((state: IApplicationState) => state.results.hasMore);
  const favoriteEntitiesLength = useSelector((state: IApplicationState) => state.results.favoriteEntities.length);
  const status = useSelector((state: IApplicationState) => state.results.status);
  const { activeTab, isInitialized } = useSelector(selectActiveTab);
  const dispatch = useDispatch();

  const loadMore = () => {
    dispatch(fetchFavoriteEntities({ offset: favoriteEntitiesLength, next: true }));
  };

  if (
    !hasMore ||
    !favoriteEntitiesLength ||
    !isInitialized ||
    activeTab === ETabType.SavedSearches ||
    activeTab === ETabType.Comparison
  ) {
    return null;
  }

  return isExperimentEnabled ? (
    <WrapContainer>
      <ShowMoreBtn onClick={loadMore} loading={status === EGetFavoriteEntitiesStatus.NextPageLoading} />
    </WrapContainer>
  ) : (
    <ShowMoreBtn onClick={loadMore} loading={status === EGetFavoriteEntitiesStatus.NextPageLoading} />
  );
};
